initVerifiedReviews();

function initVerifiedReviews() {
  const carousels = document.querySelectorAll("[data-verified-reviews-swiper]");

  if (!carousels.length || !window.Swiper) return;

  carousels.forEach((carousel) => {
    if (carousel.dataset.initialized === "true") return;

    carousel.dataset.initialized = "true";

    const style = carousel.dataset.verifiedReviewsStyle || "cards";
    const prevButton = carousel.querySelector("[data-reviews-prev]");
    const nextButton = carousel.querySelector("[data-reviews-next]");
    const pagination = carousel.querySelector("[data-reviews-pagination]");
    const mobileCards = Number(carousel.dataset.mobileCards || 1);
    const desktopCards = Number(carousel.dataset.desktopCards || 3);

    const cardsConfig = {
      slidesPerView: Math.max(1, mobileCards),
      spaceBetween: 20,
      loop: true,
      speed: 900,
      watchOverflow: true,
      centeredSlides: true,
      navigation: {
        prevEl: prevButton,
        nextEl: nextButton,
      },
      pagination: {
        el: pagination,
        clickable: true,
      },
      breakpoints: {
        768: {
          slidesPerView: Math.max(1, desktopCards),
          spaceBetween: 16,
          loop: false,
          centeredSlides: false,
        },
        1200: {
          slidesPerView: Math.max(1, desktopCards),
          spaceBetween: 19,
          loop: false,
          centeredSlides: false,
        },
      },
    };

    const quoteConfig = {
      slidesPerView: 1.08,
      spaceBetween: 16,
      speed: 500,
      centeredSlides: true,
      watchOverflow: true,
      navigation: {
        prevEl: prevButton,
        nextEl: nextButton,
      },
      pagination: {
        el: pagination,
        clickable: true,
      },
      breakpoints: {
        768: {
          slidesPerView: 2.2,
          spaceBetween: 24,
          centeredSlides: false,
        },
        1200: {
          slidesPerView: 3,
          spaceBetween: 32,
          centeredSlides: false,
        },
      },
    };

    new window.Swiper(carousel, style === "minimal" ? quoteConfig : cardsConfig);
  });
}
